module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "summary-dash"
  }, [_c('mini-weather'), _vm._v(" "), _c('mini-nagios'), _vm._v(" "), _c('div', {
    staticClass: "left-col"
  }, [_c('mini-clock'), _vm._v(" "), _c('mini-traffic')], 1), _vm._v(" "), _c('div', {
    staticClass: "mid-col"
  }, [_vm._m(0), _vm._v(" "), _c('mini-ooo')], 1), _vm._v(" "), _c('div', {
    staticClass: "right-col"
  }, [_c('mini-date'), _vm._v(" "), _c('mini-map')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-mini"
  }, [_c('div', {
    staticClass: "logo-container"
  }, [_c('img', {
    attrs: {
      "src": "images/logo-emblem.svg"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-57e573ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/summary-dash.vue
// module id = 573
// module chunks = 0